// Add this JavaScript to your slideshow component or in a separate JS file

class SlideshowDragHandler {
  constructor(slideshowElement) {
    this.slideshow = slideshowElement;
    this.slider = slideshowElement.querySelector('.slider');
    this.slides = slideshowElement.querySelectorAll('.slider__slide');
    this.prevButton = slideshowElement.querySelector('.slider-button--prev');
    this.nextButton = slideshowElement.querySelector('.slider-button--next');
    
    this.isDragging = false;
    this.hasDragged = false; // Track if user actually dragged
    this.startX = 0;
    this.startY = 0;
    this.currentX = 0;
    this.dragThreshold = 50; // Minimum distance to trigger slide change
    this.moveThreshold = 10; // Minimum movement to consider it a drag
    
    this.init();
  }
  
  init() {
    if (!this.slider || this.slides.length <= 1) return;
    
    // Add cursor styles
    this.slider.style.cursor = 'grab';
    
    // Mouse events
    this.slider.addEventListener('mousedown', this.handleStart.bind(this));
    document.addEventListener('mousemove', this.handleMove.bind(this));
    document.addEventListener('mouseup', this.handleEnd.bind(this));
    
    // Touch events for mobile compatibility
    this.slider.addEventListener('touchstart', this.handleStart.bind(this), { passive: true });
    document.addEventListener('touchmove', this.handleMove.bind(this), { passive: true });
    document.addEventListener('touchend', this.handleEnd.bind(this));
    
    // Prevent drag on images and links
    this.slider.addEventListener('dragstart', (e) => e.preventDefault());
    
    // Prevent link clicks when dragging
    this.slider.addEventListener('click', this.handleClick.bind(this), true);
  }
  
  handleStart(e) {
    this.isDragging = true;
    this.hasDragged = false;
    this.startX = this.getClientX(e);
    this.startY = this.getClientY(e);
    this.slider.style.cursor = 'grabbing';
    
    // Disable text selection
    document.body.style.userSelect = 'none';
  }
  
  handleMove(e) {
    if (!this.isDragging) return;
    
    this.currentX = this.getClientX(e);
    const currentY = this.getClientY(e);
    
    const deltaX = Math.abs(this.currentX - this.startX);
    const deltaY = Math.abs(currentY - this.startY);
    
    // Mark as dragged if movement exceeds threshold
    if (deltaX > this.moveThreshold || deltaY > this.moveThreshold) {
      this.hasDragged = true;
      e.preventDefault(); // Prevent scrolling and other default behaviors
    }
  }
  
  handleEnd(e) {
    if (!this.isDragging) return;
    
    this.isDragging = false;
    this.slider.style.cursor = 'grab';
    
    // Re-enable text selection
    document.body.style.userSelect = '';
    
    // Only process slide change if user actually dragged
    if (this.hasDragged) {
      const deltaX = this.currentX - this.startX;
      
      // Check if drag distance exceeds threshold
      if (Math.abs(deltaX) > this.dragThreshold) {
        if (deltaX > 0) {
          // Swiped right - go to previous slide
          this.prevButton?.click();
        } else {
          // Swiped left - go to next slide
          this.nextButton?.click();
        }
      }
    }
    
    // Reset values
    this.startX = 0;
    this.startY = 0;
    this.currentX = 0;
    // Don't reset hasDragged here - it's used in handleClick
  }
  
  handleClick(e) {
    // Prevent link clicks if user was dragging
    if (this.hasDragged) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
    
    // Reset drag state after a short delay to allow for click prevention
    setTimeout(() => {
      this.hasDragged = false;
    }, 10);
  }
  
  getClientX(e) {
    return e.type.includes('mouse') ? e.clientX : e.touches[0]?.clientX || 0;
  }
  
  getClientY(e) {
    return e.type.includes('mouse') ? e.clientY : e.touches[0]?.clientY || 0;
  }
}

// Initialize drag functionality when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  const slideshows = document.querySelectorAll('slideshow-component');
  slideshows.forEach(slideshow => {
    new SlideshowDragHandler(slideshow);
  });
});

// Also initialize for theme editor (Shopify admin)
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    const slideshow = event.target.querySelector('slideshow-component');
    if (slideshow) {
      new SlideshowDragHandler(slideshow);
    }
  });
}